import { PaginationRequest } from "../../objects/pagination";
import { customFetch } from "../../utils/http";

export const getMerchantTypes = async (req: PaginationRequest) => {
  const queryParams = new URLSearchParams();
  queryParams.set("page", String(req.page));
  queryParams.set("size", String(req.size));
  if (req.search) queryParams.set("search", req.search);
  if (req.status && req.status != "ALL") queryParams.set("status", req.status);
  return await customFetch(
    `v1/merchant-type?${queryParams}`,
    {
      method: "GET",
    }
  );
};

export const getMerchantType = async (id: string) => {
  return await customFetch(`v1/merchant-type/${id}`, {
    method: "GET",
  });
};
export const createMerchantType = async (data: any) => {
  return await customFetch("v1/merchant-type", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateMerchantType = async (id: string, data: any) => {
  return await customFetch(`v1/merchant-type/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteMerchantType = async (id: string) => {
  return await customFetch(`v1/merchant-type/${id}`, {
    method: "DELETE",
  });
};


